import { createContext } from 'react';

export const AuthContext = createContext({
    user_id: null,
    username: '',
    access_level: null,
    permission_ids: []
});

export const LoadingContext = createContext({
    isLoading: null
});

export const ClinicListContext = createContext([]);
export const PatientListContext = createContext([]);